export const module = {
    info: {
        name: 'user-reseller-features',
        caption: 'User Reseller Features'
    },
    vuexModules: ['api', 'state'],
    mainRoute: '/cpanel',
    noRoutes: true,
}

export default module
